/**
 * author: 胡枭
 * desc: 竞价相关的数据字典
 * 这里对象的key，即为value的值
 */
import Dict from '@/utils/dict-utils'

// 竞价状态数据字典
export const competeStatusDict = new Dict({
  NOT_STARTED: {
    value: 0,
    label: '未发布',
    type: 'warning',
    permission: ['edit', 'delete']
  },
  ACCEPTING: {
    value: 1,
    label: '接受报名中',
    type: 'primary',
    permission: ['detail', 'copy'],
    routerName: 'SignUpSituation'
  },
  APPLICATION_CLOSED: {
    value: 2,
    label: '报名已截止',
    type: 'primary',
    permission: ['detail', 'copy'],
    routerName: 'CompeteHallDoor'
  },
  IN_BIDDING: {
    value: 3,
    label: '竞价中',
    type: 'primary',
    permission: ['compete', 'copy'],
    routerName: 'CompeteHallDoor'
  },
  FINISH_BIDDING: {
    value: 4,
    label: '竞价完成',
    type: 'primary',
    permission: ['detail', 'copy'],
    routerName: 'CompetePublicNotice'
  },
  ENDED: {
    value: 5,
    label: '已结束',
    type: 'success',
    permission: ['detail', 'copy'],
    routerName: 'CompetePublicNotice'
  },
  ABORTED: {
    value: 6,
    label: '终止竞价',
    type: 'info',
    permission: ['detail', 'copy'],
    routerName: 'CompeteDetail'
  },
  RESTART: {
    value: 7,
    label: '重新竞价',
    type: 'info',
    permission: ['detail', 'copy'],
    routerName: 'CompeteDetail'
  },
  DOING: {
    value: 99,
    label: '进行中',
    type: 'primary',
    permission: ['look', 'copy'],
    routerName: 'CompeteDetail'
  }
})

// 竞价类型
export const competeTypeDict = new Dict({
  PUBLIC_COMPETE: { value: 0, label: '公开竞价' },
  INVITE_COMPETE: { value: 1, label: '邀请竞价' }
})

// 是否需要报名审核
export const competeNeedReviewDict = new Dict({
  NO: { value: 0, label: '否' },
  YES: { value: 1, label: '是' }
})

// 竞价方式
export const competeMethodDict = new Dict({
  COMPETE_HIGH: {
    value: 1,
    label: '竞高价',
    dispelDoubts: '适用于竞价拍卖场景'
  },
  COMPETE_LOW: { value: 0, label: '竞低价', dispelDoubts: '适用于租赁采购场景' }
})

// 邀请类型
export const competeInviteTypeDict = new Dict({
  CREATE_INVITE: { value: 0, label: '发布时邀请' },
  ADD_INVITE: { value: 1, label: '追加邀请' }
})

// 报价是否含税
export const competeRequireTaxDict = new Dict({
  YES: { value: 1, label: '是' },
  NO: { value: 0, label: '否' }
})

// 是否公开竞价公司
export const competeWhetherOpenDict = new Dict({
  YES: { value: 1, label: '是' },
  NO: { value: 0, label: '否' }
})

// 是否发布公告
export const competeWhetherAnnouncementDict = new Dict({
  YES: { value: 1, label: '是' },
  NO: { value: 0, label: '否' }
})

// 竞价大厅的状态
export const competeHallStatusDict = new Dict({
  NOT_STARTED: { value: 8, label: '竞价未开始' },
  ABOUT_TO_START: { value: 9, label: '竞价未开始' }, // 即将开始
  COMPETE: { value: 3, label: '竞价中' },
  COMPETE_END: { value: 4, label: '竞价结束' }
})

// 成交供应商状态
export const competePublicNoticeStatusDict = new Dict({
  NOT_STARTED: { value: 0, label: '未成交' },
  STORE: { value: 1, label: '保存成交供应商' },
  RELEASE: { value: 2, label: '发布成交供应商' }
})

// 流标状态
export const competeAbortiveStatusDict = new Dict({
  RESTART: { value: 1, label: '重新竞价' },
  STOP: { value: 2, label: '停止竞价' }
})

// （供应商）竞价大厅节点状态
export const supplierCompeteHallStatusDict = new Dict({
  NOT_STARTED: { value: 0, label: '竞价未开始', type: 'info' }, // 初始状态
  TIME_BEFORE: { value: 1, label: '竞价未开始', type: 'info' }, // 未到进入竞价大厅的时间
  TIME_IS_UP: { value: 2, label: '进入竞价大厅', type: 'success' }, // 已到进入竞价大厅的时间（包括竞价开始和竞价开始的前一小时内）
  TIME_END: { value: 3, label: '竞价已结束', type: 'info' }, // 竞价结束
  NO_COMPETE: { value: 9, label: '项目已流标，无法竞价', type: 'danger' }
})
